import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { useAuthContext } from '../../context/auth/auth'
import { Cancellation } from '../../interfaces/cancellation'
import {
  buildCancellationParams,
  CancellationFilters,
} from './cancellationParams'

// Super administrators only - anyone else gets a 403. Unpaginated and wrapped
// under `data`, the same as `/payment/payments/`, so the payload is a bare
// array rather than `{ count, results }`.
const CANCELLATIONS_ENDPOINT = '/payment/cancellations/'

const getCancellations = async (
  token: string,
  params: Record<string, string>,
): Promise<Cancellation[]> => {
  const response = await instance.get(CANCELLATIONS_ENDPOINT, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  })

  return response.data.data
}

/**
 * Every filter the toolbar offers is applied by the backend; the table sorts
 * what comes back. `keepPreviousData` holds the previous rows on screen while
 * a changed filter is in flight, so typing in the search box does not flash
 * the table through its "no cancellations found" state on every keystroke.
 */
const useCancellations = (filters: CancellationFilters) => {
  const { token } = useAuthContext()
  const params = buildCancellationParams(filters)

  return useQuery({
    queryKey: ['cancellations', params],
    queryFn: () => getCancellations(token!, params),
    keepPreviousData: true,
  })
}

export default useCancellations
